import * as actions from './actions';
import store from "./store";


export default Object.keys(actions).reduce( (acc, key) => {

    return {
        ...acc,
        [key]: (value) => store.dispatch( actions[key](value) )
    }
}, {});